const BASE_URL = process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL;
export const HEADER_LINKS = [
  {
    id: 'help-healing',
    title: 'Help & Healing',
    hasPromo: true,
    promo: {
      title: 'Free. Confidential. 24/7.',
      description: 'Talk to a trained staff member who can provide confidential support.',
      buttonText: 'I need help now',
      buttonUrl: `${BASE_URL}/hotline-landing-page/`,
    },
    columns: [
      [
        { title: `If You've Been Assaulted`, url: `${BASE_URL}/help-and-healing/if-youve-been-assaulted/` },
        { title: 'Seeking Medical Attention', url: `${BASE_URL}/help-and-healing/if-youve-been-assaulted/getting-medical-help-after-sexual-assault/` },
        { title: 'Reporting to Law Enforcement ', url: `${BASE_URL}/help-and-healing/if-youve-been-assaulted/reporting-sexual-assault-to-law-enforcement/` },
        { title: 'How To Report Tech-Enabled Sexual Abuse', url: `${BASE_URL}/help-and-healing/reporting-sexual-assault-to-law-enforcement/how-to-report-tech-enabled-sexual-abuse/` },
        { title: 'For Survivors of Child Sexual Abuse ', url: `${BASE_URL}/help-and-healing/for-survivors-of-child-sexual-abuse/` },
      ],
      [
        { title: 'Overcoming Trauma', url: `${BASE_URL}/overcoming-trauma-after-sexual-violence/` },
        { title: 'How To Talk About It ', url: `${BASE_URL}/overcoming-trauma-after-sexual-violence/how-to-tell-someone-you-were-sexually-assaulted/` },
        { title: 'Mental Health Support ', url: `${BASE_URL}/help-and-healing/overcoming-trauma-after-sexual-violence/mental-health-therapy-support-after-sexual-violence/` },
        { title: 'Self-Care  ', url: `${BASE_URL}/help-and-healing/overcoming-trauma-after-sexual-violence/self-care/` },
      ],
    ],
  },
  {
    id: 'get-informed',
    title: 'Get Informed',
    hasPromo: false,
    columns: [
      [
        { title: 'Get the Facts About Sexual Violence ', url: `${BASE_URL}/get-the-facts-about-sexual-violence/` },
        { title: 'Facts and Statistics: The Scope of the Problem ', url: `${BASE_URL}/get-informed/facts-statistics-the-scope-of-the-problem/` },
        { title: 'What Does Consent Look Like? ', url: `${BASE_URL}/share-the-facts/consent-101-respect-boundaries-and-building-trust/` },
        { title: 'What "Counts" as Sexual Violence?  ', url: `${BASE_URL}/get-informed/get-the-facts-about-sexual-violence/what-counts-as-sexual-violence/` },
        { title: 'What Warning Signs Should I Watch For?  ', url: `${BASE_URL}/get-informed/prevention/prevention-tips-for-parents-caregivers/warning-signs-to-watch-for/` },
      ],
      [
        { title: 'Prevention ', url: `${BASE_URL}/prevention/` },
        { title: 'Safer Strategies', url: `${BASE_URL}/get-informed/prevention/strategies-to-reduce-risk-increase-safety/` },
        { title: 'Prevention Tips for Parents & Caregivers ', url: `${BASE_URL}/get-informed/prevention/prevention-tips-for-parents-caregivers/` },
        { title: 'Prevention Tips for Students', url: `${BASE_URL}/get-informed/prevention/prevention-tips-for-students/` },
      ],
      [
       { title: 'Issue Hub ', url: `${BASE_URL}/get-informed/issues//` },
        { title: 'AI & Tech-Enabled Sexual Abuse', url: `${BASE_URL}/get-informed/issues/ai-tech-enabled-sexual-abuse/` },
        { title: 'Children & Sexual Violence: What You Need to Know', url: `${BASE_URL}/get-informed/issues/children-and-sexual-violence/` },
      ],
    ],
  },
  {
    id: 'show-support',
    title: 'Show Support',
    hasPromo: true,
    promo: {
      title: 'Strength To Care',
      description: 'Show up, speak out, and step in with everyday acts of care.',
      buttonText: 'Join The Movement',
      buttonUrl: `${BASE_URL}/show-support/strength-to-care/`,
    },
    columns: [
      [
        { title: 'Support Someone You Care About ', url: `${BASE_URL}/show-support/show-up-speak-out-step-in/` },
        { title: 'Help Survivors HEAL ', url: `${BASE_URL}/show-up-speak-out-step-in/show-up-to-help-survivors-heal/` },
        { title: 'How To TALK About It ', url: `${BASE_URL}/show-up-speak-out-step-in/how-to-talk-with-survivors-of-sexual-violence/` },
        { title: 'Disrupt Harm ', url: `${BASE_URL}/show-up-speak-out-step-in/stop-sexual-violence-step-in-with-care/` },
      ],
      [
        { title: 'Support Survivors Through Giving  ', url: `${BASE_URL}/give-to-rainn/` },
        { title: 'Donate Now ', url: 'https://rainn.givevirtuous.org/donate/donate-subdomain' },
        { title: 'Give Monthly ', url:  `${BASE_URL}/give-to-rainn/the-hope-network/` },
        { title: 'Corporate & Foundation Partners ', url: `${BASE_URL}/learn-about-rainn/mission-and-vision/our-partners/` },
        { title: 'Host a Fundraiser ', url: `${BASE_URL}/give-to-rainn/host-a-fundraiser/` },
      ],
    ],
  },
  {
    id: 'take-action',
    title: 'Take Action',
    hasPromo: false,
    columns: [
      [
        { title: 'Discover SAAPM 365 ', url: `${BASE_URL}/take-action/saapm365/` },
        { title: 'Get the Community Outreach Toolkit ', url: `${BASE_URL}/take-action/community-outreach-toolkit/` },
        { title: 'Share Your Story ', url: `${BASE_URL}/show-support/share-your-story/` },
        { title: 'Volunteer with RAINN ', url: `${BASE_URL}/take-action/fight-for-justice/volunteer-with-rainn/` },
      ],
      [
        { title: 'Fight for Justice ', url: `${BASE_URL}/take-action/fight-for-justice/` },
        { title: 'Advocate With RAINN ', url: `${BASE_URL}/take-action/cda/`},
        { title: 'Laws In Your State ', url: `${BASE_URL}/take-action/fight-for-justice/state-law-database/` },
        { title: 'Grassroots Advocacy 101  ', url: `${BASE_URL}/fight-for-justice/grassroots-advocacy-your-guide-to-impacting-anti-sexual-violence-laws/` },
      ],
      [
        { title: 'Transform Your Workplace ', url: `${BASE_URL}/learn-about-rainn/what-we-do/consulting-and-training/` },
        { title: 'Client-Branded Hotlines ', url: `${BASE_URL}/consulting-and-training/client-branded-hotlines/` },
        { title: 'Workplace Sexual Misconduct: Best Practices & Prevention Strategies', url: `${BASE_URL}/2025/06/19/workplace-sexual-misconduct-best-practices-prevention-strategies/`},
        { title: 'Training and Education  ', url: `${BASE_URL}/consulting-and-training/training-and-education/` },
        { title: 'Arts & Entertainment Consulting', url: `${BASE_URL}/consulting-and-training/arts-entertainment-consulting/` },
      ],
    ],
  },
  {
    id: 'learn-about-rainn',
    title: 'Learn About RAINN',
    hasPromo: false,
    columns: [
       [
        { title: 'Who We Are ', url: `${BASE_URL}/learn-about-rainn/mission-and-vision/` },
        { title: 'Our Impact', url: `${BASE_URL}/learn-about-rainn/mission-and-vision/our-impact/` },
        { title: 'Our Partners ', url: `${BASE_URL}/learn-about-rainn/mission-and-vision/our-partners/` },
        { title: 'Our People ', url: `${BASE_URL}/learn-about-rainn/mission-and-vision/our-people/` },
      ],
      [
        { title: 'What We Do ', url: `${BASE_URL}/learn-about-rainn/what-we-do/` },
        { title: 'Support & Services ', url: `${BASE_URL}/learn-about-rainn/what-we-do/support-and-services/` },
        { title: 'Education & Community ', url: `${BASE_URL}/learn-about-rainn/what-we-do/education-and-community/` },
        { title: 'Policy & Justice  ', url: `${BASE_URL}/learn-about-rainn/what-we-do/policy-and-justice/` },
        { title: 'Consulting and Training ', url: `${BASE_URL}/learn-about-rainn/what-we-do/consulting-and-training/` },
      ],
      [
        { title: 'Impact Hub ', url: `${BASE_URL}/learn-about-rainn/impact-hub/` },
        { title: 'Press Room ', url: `${BASE_URL}/learn-about-rainn/impact-hub/press-room/` },
        { title: 'Policy Center ', url: `${BASE_URL}/learn-about-rainn/impact-hub/policy-center/` },
        { title: 'Entertainment & Storytelling Center  ', url: `${BASE_URL}/learn-about-rainn/impact-hub/entertainment-storytelling-center/` },
        { title: 'Service Provider Resource Center ', url: `${BASE_URL}/service-provider-resource-center/` },
      ],
    ],
  }
];	